const TRANSLATIONS_PLATFORM = 'OP_COB_WEB';

export { TRANSLATIONS_PLATFORM };
